var Feedback;
jQuery(function ($) {
    Feedback = {
        refreshCahced: function () {
            var postId = jQuery('#feedback').attr('data-post-id');

            if (typeof postId === 'undefined') {
                return;
            }

            Page.startLoad('feedback', jQuery('#feedback'));

            jQuery.post(ajaxurl, {
                action: 'post_feedback_form',
                post_id: postId
            }, function (res) {
                Page.finishLoad('feedback');

                if (res.length) {
                    jQuery('#feedback').replaceWith(res);
                }
            }, 'html');
        },
        initScores: function () {
            jQuery(document).on('change', '#feedback [name="feedback_score"]', function () {
                var score = jQuery(this).val(),
                    feedbackContainerEl = jQuery('#feedback'),
                    postId = feedbackContainerEl.attr('data-post-id');

                jQuery('.feedback-sent-holder').addClass('hidden');
                jQuery('.feedback-note-holder').addClass('hidden');

                Page.startLoad('feedback', feedbackContainerEl);

                jQuery.post(ajaxurl, {
                    action: 'post_feedback_score',
                    post_id: postId,
                    score: score
                }, function (res) {
                    Page.finishLoad('feedback');

                    if (res.success) {
                        if (res.has_note) {
                            jQuery('.feedback-note-holder').remove();
                        }

                        if (score < 3) {
                            jQuery('.feedback-note-holder').removeClass('hidden');
                        } else {
                            jQuery('.feedback-sent-holder').removeClass('hidden');
                        }

                        //update totals
                        if (res.feedback_totals) {
                            jQuery('.feedback-totals .totals-content').html(res.feedback_totals);
                        }
                    }
                }, 'json');
            });
        },
        initNote: function () {
            jQuery(document).on('click', '#feedback #submit_feedback_note', function () {
                var postId = jQuery('#feedback').attr('data-post-id'),
                    note = jQuery('#feedback_note').val(),
                    email = jQuery('#feedback_email').val();

                jQuery('.thanks-for-feedback').addClass('hidden');
                Page.startLoad('feedback', jQuery('.feedback-note-holder'));

                if (note.length) {
                    jQuery.post(ajaxurl, {
                        action: 'post_feedback_note',
                        post_id: postId,
                        note: note,
                        email: email
                    }, function (res) {
                        Page.finishLoad('feedback');

                        if (res.success) {
                            Template.popup(jQuery('#feedback_thanks_popup'), {}, {'className': 'feedback-thanks-popup'});
                            jQuery('.feedback-note-holder').remove();
                        } else if (typeof res.errors !== 'undefined') {
                            Validator.validateModel(jQuery('.feedback-note-holder'), res.errors);
                        }
                    }, 'json');
                }
            });
        },
        init: function () {
            this.refreshCahced();
            this.initScores();
            this.initNote();
        }
    };

    Feedback.init();
});